var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('t-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();}}},[_c('ServiceRadioFormPart',{on:{"result":_vm.onResult,"change":_vm.onChange}})],1),_vm._v(" "),_c('FormErrorMessages',{attrs:{"error-messages":_vm.errorMessages}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }